
import { logger } from "../../utils/logger";
import { mat4, vec3 } from "gl-matrix";


class BaseRender {

    width = 0;
    height = 0;

    renderOptions = {}

    tag = 'BaseRender'

    constructor(width, height, renderOptions) {

        this.width = width
        this.height = height
        Object.assign(this.renderOptions, this.renderOptions, renderOptions)

        this.updateColorMatrix();
        
    }

    updateColorMatrix() {


        let contrast = this.renderOptions.contrast
        contrast -= 1.0
        contrast = (contrast < 0.0) ? (1.0 / (-contrast + 1.0))
                         : (contrast + 1.0);
   
        let con_matrix = [contrast, 0.0, 0.0, 0.0, 0.0, contrast, 0.0, 0.0, 0.0, 0.0, contrast, 0.0, 0.0, 0.0, 0.0, 1.0];
    
        let brightness = this.renderOptions.brightness

        brightness -= 1.0
        let bright_matrix = mat4.create()
        mat4.identity(bright_matrix)
        // bright_matrix[12] = brightness
        // bright_matrix[13] = brightness
        // bright_matrix[14] = brightness

        mat4.translate(bright_matrix, bright_matrix, [brightness, brightness, brightness])

        let saturation = this.renderOptions.saturate

        const red_weight = 0.299;
        const green_weight = 0.587;
        const blue_weight = 0.114;
        let one_minus_sat_red = (1.0 - saturation) * red_weight;
        let one_minus_sat_green = (1.0 - saturation) * green_weight;
        let one_minus_sat_blue = (1.0 - saturation) * blue_weight;
        let sat_val_red = one_minus_sat_red + saturation;
        let sat_val_green = one_minus_sat_green + saturation;
        let sat_val_blue = one_minus_sat_blue + saturation;
    
       
        let sat_matrix = [sat_val_red, one_minus_sat_red, one_minus_sat_red, 0.0,
                          one_minus_sat_green, sat_val_green, one_minus_sat_green, 0.0,
                          one_minus_sat_blue, one_minus_sat_blue, sat_val_blue, 0.0,
                           0.0, 0.0, 0.0, 1.0];
    

        let hue_shift = this.renderOptions.huerotate;
    
        const  root3 = 0.57735
        const M_PI = 3.1415926
        /* Hue is the radian of 0 to 360 degrees. */
        let half_angle = 0.5 *(hue_shift / (180.0 / M_PI));
    
   
        let rot_quad1 = root3 * Math.sin(half_angle);
        let rot_quaternion = [rot_quad1, rot_quad1, rot_quad1];
 
        let rot_quaternion_w = Math.cos(half_angle);

        let cross = vec3.create()
        vec3.mul(cross, rot_quaternion, rot_quaternion)

        let square = vec3.create()
        vec3.mul(square, rot_quaternion, rot_quaternion)

        let wimag = vec3.create()
        vec3.mul(wimag, rot_quaternion, [rot_quaternion_w, rot_quaternion_w, rot_quaternion_w])

        vec3.mul(square, square, [2.0, 2.0, 2.0])
      
        let diag = vec3.create()
        vec3.sub(diag, [0.5, 0.5, 0.5], square)

        let a_line = vec3.create()
        vec3.add(a_line, cross, wimag)

        let b_line = vec3.create()
        vec3.sub(b_line, cross, wimag)
    
        let hue_op_matrix = [diag[0] * 2.0,
                             b_line[2] * 2.0,
                             a_line[1] * 2.0,
                             0.0,
                             a_line[2] * 2.0,
                             diag[1] * 2.0,
                             b_line[0] * 2.0,
                             0.0,
                             b_line[1] * 2.0,
                             a_line[0] * 2.0,
                             diag[2] * 2.0,
                             0.0,
                             0.0,
                             0.0,
                             0.0,
                             1.0];

        
        let final_matrix = mat4.create()
        
        mat4.multiply(final_matrix, con_matrix, bright_matrix)
        mat4.multiply(final_matrix, final_matrix, sat_matrix)
        mat4.multiply(final_matrix, final_matrix, hue_op_matrix)
    
        this.colorMatrix = final_matrix

    }

    //interface

    resizeView(width, height) {

        this.width = width
        this.height = height

        this.doResizeView()
    }

    updateRenderOptions(renderOptions) {

        Object.assign(this.renderOptions, this.renderOptions, renderOptions)
        this.updateColorMatrix();
        this.doUpdateRenderOptions()
    }

   
    destroy() {

        logger.info(this.tag, 'BaseRender destroy');

    }


    //subclass implemtaition
    doResizeView() {


    }

    doUpdateRenderOptions() {
   
    }


}

export default BaseRender;